import React from "react";
import Layout from "../components/UI/layout";
import { SEO as Seo } from "../components/UI/seo";
import ContactBanner from "../components/Contact/ContactBanner/ContactBanner";
import ContactData from "../components/Contact/ContactData/ContactData";
import * as styles from "../components/Contact/Contact.module.scss";
import ContactForm from "../components/Contact/ContactForm/ContactForm";

const ContactPage = () => {
  return (
    <Layout>
      <div className="section">
        <ContactBanner />
        <div className={`${styles.Container} container`}>
          <ContactForm />
          <ContactData />
        </div>
      </div>
    </Layout>
  );
};

export default ContactPage;

export const Head = () => (
  <Seo 
    title="Contacto | Email y Whatsapp | Peabody Argentina"
    description="¿Tenés alguna consulta? Estamos aquí para ayudarte! Envianos un correo electrónico o un mensaje a nuestro whatsapp. Brindamos soporte general y soporte técnico."
  >
    <link rel="canonical" href="https://peabody.com.ar/contacto/"/>
  </Seo>
)
